import { z } from 'zod'

export enum ExportFormat {
  Excel = 'xlsx',
  Word = 'docx',
}

export const ExportSchema = z.object({
  id: z.string().uuid(),
  status: z.enum(['pending', 'running', 'completed', 'failed']),
  error: z.string().nullable(),
  download_url: z.string().url().nullable(),
  expires_at: z.string().datetime({ offset: true }),
})
export type TableExport = z.infer<typeof ExportSchema>

export type TableExportQuery = Pick<
  import('../schemas').TableQuery,
  'filters' | 'sorts' | 'filter_match' | 'search' | 'search_column_ids' | 'search_filenames'
> & {
  format?: ExportFormat
  include_footnotes?: boolean
  column_ids?: string[]
  pinned_column_ids?: string[]
  entry_column_index?: number | null
  entry_column_pinned?: boolean
}
